import { Modal } from 'bootstrap';

const navShadow = document.getElementsByClassName('nav__bg')[0];
const dropdowns = document.querySelectorAll('nav .dropdown');
dropdowns.forEach((dropdown) => {
  dropdown.addEventListener('show.bs.dropdown', () => {
    navShadow.classList.add('show');
  });
  dropdown.addEventListener('hide.bs.dropdown', () => {
    navShadow.classList.remove('show');
  });
});
